/*
 * サブシステム名：OTM受付一覧編集
 * 機能名：受付一覧編集
 */
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import date from '@/ddv2.library/date'
// import d2fmt from '@/ddv2.library/utils/formatter'
import header from '@/ddv2.library/header'

import DdDateBox from '@/components/DdDateBox'
import DdCustomButton from '@/components/DdCustomButton'
import DdSpreadSheet from '@/components/DdSpreadSheet'
import DdTransparentButton from '@/components/DdTransparentButton'

export default {
  name: 'OtmDeliveryLedger',
  mixins: [flowMixin],
  components: {
    DdDateBox,
    DdCustomButton,
    DdSpreadSheet,
    DdTransparentButton
  },
  data: () => ({
    // 一覧制御用
    rows: [],
    selected: [],
    itemsPerPage: 100,
    page: 1,

    conditions: {},
    // ヘッダー定義
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersJininList: header.mstJininHeaders,
    headersTorihikisakiList: header.mstTorihikisaki,

    // 制御用
    modeKengen: 0,
    pageCount: 0,

    // スプレッドシートオプション
    option: {
      // テーブル最大高さ
      tableHeight: '60vh',
      // テーブル最大横幅
      tableWidth: 'inherit',
      // 列追加
      allowInsertColumn: false,
      // 行追加※改行キーのみ
      allowManualInsertRow: false,
      // 列削除
      allowDeleteColumn: false,
      // 行削除
      allowDeleteRow: false,
      // 列ドラッグ
      columnDrag: false,
      // 行ドラッグ
      rowDrag: false,
      // ソート
      columnSorting: true,
      // スクロール有効化
      tableOverflow: true,
      // コンテキストメニュー
      contextmenu: false,
      // セル内HTML無効※ヘッダー改行のため有効
      stripHTML: false,
      // 計算式のサポート
      parseFormulas: true,
      // セル選択時の右下の■ドラッグでのコピー
      selectionCopy: true,
      // CSV出力
      allowExport: false,
      // フィルターオプション
      search: true,
      // ページネーションオプション
      pagination: 30,
      paginationOptions: [15, 30, 60, 180, 300],
      // デフォルト文言変更
      text: {
        show: '1ページ当たりの行数:',
        entries: '',
        showingPage: '全部で {1} ページあります',
        search: 'さらにフリーワードで絞り込む',
        noRecordsFound: '対象データがありません'
      }
    },
    // 画面側からのエラーリスト
    outsideErrorList: []
  }),
  watch: {
    /**
     * 検索条件簡易表示用
     * @param {} n
     */
    // 配送日
    'conditions.sagyoYoteiStartYmd': function (n) {
      var sagyoYmdFromTo = ![undefined, null, ''].includes(this.conditions.sagyoYoteiStartYmdString) ? this.conditions.sagyoYoteiStartYmdString.slice(-5) : ''
      sagyoYmdFromTo = sagyoYmdFromTo + (![undefined, null, ''].includes(this.conditions.sagyoYoteiEndYmdString) ? '～' + this.conditions.sagyoYoteiEndYmdString.slice(-5) : '')
      this.conditions.sagyoYmdFromTo = sagyoYmdFromTo
    },
    'conditions.sagyoYoteiEndYmd': function (n) {
      var sagyoYmdFromTo = ![undefined, null, ''].includes(this.conditions.sagyoYoteiStartYmdString) ? this.conditions.sagyoYoteiStartYmdString.slice(-5) : ''
      sagyoYmdFromTo = sagyoYmdFromTo + (![undefined, null, ''].includes(this.conditions.sagyoYoteiEndYmdString) ? '～' + this.conditions.sagyoYoteiEndYmdString.slice(-5) : '')
      this.conditions.sagyoYmdFromTo = sagyoYmdFromTo
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      eigyoshoList: 'DDMasters/mstEigyosho',
      JininList: 'DDMasters/vwCMstEigyoshoJininList',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      hinmeiList: 'DDMasters/mstHinmei',
      usersEigyoshoCd: 'users/eigyoshoCd',
      helpUseFlg: 'users/helpUseFlg'
    }),
    // 取引先フィルター
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    // 得意先フィルター
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    // 営業所フィルター
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      })
    },
    // 人員フィルター
    filteredJininList () {
      const target = filter.dateFormatter(new Date())
      return this.JininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    isMultiSaveButtonDisabled () {
      return false
    },

    computedColNumList () {
      var result = {}
      this.headers.forEach((elem, index) => {
        result[elem.name] = index
      })
      return result
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    // **************************************************
    // 初期化
    // **************************************************
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist', 'msttorihikisaki', 'msthacchakuchi', 'msthinmei'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.setHeader()
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          console.log('★★★', self.conditions)
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('OtmDeliveryLedger.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('OtmDeliveryLedger.researchPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('OtmDeliveryLedger.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('OtmDeliveryLedger.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    initBindVariables: function () {
      this.$set(this.conditions, 'baseYmd', date.getCurrentDate())

      this.onSearchButtonClick()
    },

    // 日付関連
    calcBaseDate: function (val) {
      if (val === null) {
        this.conditions.baseYmd = date.getCurrentDate()
      } else {
        const tmpDate = new Date(this.conditions.baseYmd)
        const currentDate = new Date(tmpDate)
        currentDate.setDate(tmpDate.getDate() + val)
        this.conditions.baseYmd = `${currentDate.getFullYear()}/${String(currentDate.getMonth() + 1).padStart(2, '0')}/${String(currentDate.getDate()).padStart(2, '0')}`
      }
    },

    // --------------------------------------------------
    // 検索ボタン押下
    // --------------------------------------------------
    onSearchButtonClick: function () {
      this.setHeader()

      // ダミーデータ作成
      for (let i = 0; i < 465; i++) {
        this.rows.push({
          key0: i < 60 ? 1 : i < 105 ? 2 : i < 150 ? 3 : i < 195 ? 4 : i < 240 ? 5 : i < 285 ? 6 : i < 375 ? 7 : i < 420 ? 8 : i < 444 ? 9 : 10,
          key1: i < 60 ? '①【納品】自社１直『１５ｔ』' : i < 105 ? '②【納品】パ社１直『ＳＫ』' : i < 150 ? '③【納品】パ社１直『【日立』' : i < 195 ? '④【納品】自社２直『１５ｔ』' : i < 240 ? '⑤【保管】自社２直『２０ｔ』' : i < 285 ? '⑥【保管】パ社２直『２０ｔ』' : i < 375 ? '⑦【保管】パ社２直『１５ｔ』' : i < 420 ? '⑧【保管】スポット' : i < 444 ? '⑨夜間保管移動' : '⑩アベックス',
          key2: '',
          key3: '',
          key4: '',
          key5: '',
          company: '',
          sharyo: '',
          driver: '',
          f0: '',
          tsumichi1: '',
          oroshichi1: '',
          memo1: '',
          f1: '',
          tsumichi2: '',
          oroshichi2: '',
          memo2: '',
          f2: '',
          tsumichi3: '',
          oroshichi3: '',
          memo3: '',
          f3: '',
          tsumichi4: '',
          oroshichi4: '',
          memo4: '',
          f4: '',
          tsumichi5: '',
          oroshichi5: '',
          memo5: '',
          f5: ''
        })
      }
    },

    // --------------------------------------------------
    // クリアボタン押下
    // --------------------------------------------------
    onClearButtonClick: function () {
      this.initBindVariables()
      this.rows = []
    },

    // --------------------------------------------------
    // 行追加ボタン押下
    // --------------------------------------------------
    onNewRowButtonClick: function () {
      this.rowAppend(1, false, true)
    },

    // --------------------------------------------------
    // 変更ボタン押下
    // --------------------------------------------------
    onMultiSaveButtonClick: function () {
    },

    /**
     * スプレッドシート制御
     * @returns
     */
    onLoadDataAfter () {
      const self = this
      for (let y = 0; y < self.rows.length; y++) {
        for (let x = 0; x < 5; x++) {
          self.$refs.ddSpreadSheet.setCellClass(x, y, `key-info-${self.rows[y].key0}`)
        }
        if ((y + 1) % 3 === 1) {
          for (let x = 9; x < 29; x++) {
            self.$refs.ddSpreadSheet.setCellClass(x, y, 'tsumi-oroshi-info')
          }
          const cellName = this.$refs.ddSpreadSheet.getCellNameFromCoords(29, y)
          const getMerge = this.$refs.ddSpreadSheet.jspreadsheetObj.getMerge(cellName)
          if (!getMerge || getMerge.toString() !== '1,3') {
            this.$refs.ddSpreadSheet.jspreadsheetObj.setMerge(cellName, 1, 3)
          }
        }
        if ((y + 1) % 3 === 2) {
          for (let xx = 9; xx < 29; xx += 4) {
            const cellName = this.$refs.ddSpreadSheet.getCellNameFromCoords(xx, y)
            const getMerge = this.$refs.ddSpreadSheet.jspreadsheetObj.getMerge(cellName)
            if (!getMerge || getMerge.toString() !== '2,1') {
              this.$refs.ddSpreadSheet.jspreadsheetObj.setMerge(cellName, 2, 1)
            }
          }
        }
      }
    },
    setHeader: function () {
      console.log('setHeader')
      const self = this
      return new Promise(resolve => {
        // 現在日付取得
        // const target = filter.dateFormatter(new Date())

        // --------------------------------------------------------------------------------
        // スプレッド用ドロップダウン作成
        // --------------------------------------------------------------------------------
        // 現状ない

        self.headers = [
          // 絞り込み情報
          { title: ' ', name: 'key1', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: true, width: '25px' },
          { title: ' ', name: 'key2', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: true, width: '25px' },
          { title: ' ', name: 'key3', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: true, width: '25px' },
          { title: ' ', name: 'key4', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: true, width: '25px' },
          { title: ' ', name: 'key5', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: true, width: '25px' },
          // 運行情報
          { title: '配送会社', name: 'company', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: false, width: '140px' },
          { title: '車両', name: 'sharyo', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: false, width: '100px' },
          { title: 'ドライバー', name: 'driver', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: false, width: '100px' },
          { title: ' ', name: 'f0', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: true, width: '10px' },
          // 1回転目
          { title: '積地', name: 'tsumichi1', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: false, align: 'center', width: '120px' },
          { title: '卸地', name: 'oroshichi1', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: false, align: 'center', width: '120px' },
          { title: ' ', name: 'memo1', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: false, align: 'center', width: '30px' },
          { title: ' ', name: 'f1', type: 'text', validateType: 'Free', validateLength: 50, required: false, readOnly: true, align: 'center', width: '10px' },
          // 2回転目
          { title: '積地', name: 'tsumichi2', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: false, align: 'center', width: '120px' },
          { title: '卸地', name: 'oroshichi2', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: false, align: 'center', width: '120px' },
          { title: ' ', name: 'memo2', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: false, align: 'center', width: '30px' },
          { title: ' ', name: 'f2', type: 'text', validateType: 'Free', validateLength: 50, required: false, readOnly: true, align: 'center', width: '10px' },
          // 3回転目
          { title: '積地', name: 'tsumichi3', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: false, align: 'center', width: '120px' },
          { title: '卸地', name: 'oroshichi3', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: false, align: 'center', width: '120px' },
          { title: ' ', name: 'memo3', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: false, align: 'center', width: '30px' },
          { title: ' ', name: 'f3', type: 'text', validateType: 'Free', validateLength: 50, required: false, readOnly: true, align: 'center', width: '10px' },
          // 4回転目
          { title: '積地', name: 'tsumichi4', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: false, align: 'center', width: '120px' },
          { title: '卸地', name: 'oroshichi4', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: false, align: 'center', width: '120px' },
          { title: ' ', name: 'memo4', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: false, align: 'center', width: '30px' },
          { title: ' ', name: 'f4', type: 'text', validateType: 'Free', validateLength: 50, required: false, readOnly: true, align: 'center', width: '10px' },
          // 5回転目
          { title: '積地', name: 'tsumichi5', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: false, align: 'center', width: '120px' },
          { title: '卸地', name: 'oroshichi5', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: false, align: 'center', width: '120px' },
          { title: ' ', name: 'memo5', type: 'text', validateType: 'Free', validateLength: 100, required: false, readOnly: false, align: 'center', width: '30px' },
          { title: ' ', name: 'f5', type: 'text', validateType: 'Free', validateLength: 50, required: false, readOnly: true, align: 'center', width: '10px' },
          // メモ
          { title: '連絡用備考', name: 'renrakuBiko', type: 'text', validateType: 'Free', validateLength: 400, required: false, readOnly: false, width: '250px' }
        ]
      })
    },
    rowAppendAvobe: function (num) {
      this.rowAppend(num, true)
    },
    rowAppendBelow: function (num) {
      this.rowAppend(num, false)
    },
    rowAppend: function (num, aboveFlg, lastFlg) {
      // 現在の選択セル
      var activeC = this.$refs.ddSpreadSheet.getActiveCell()
      // 行追加先の位置を取得
      var pos = 0
      // 全選択状態なら先頭行に追加
      var isAllSelect = false
      if (!activeC) {
        // セル未選択
      } else if (activeC.length > 3) {
        // セル選択
        pos = Math.max(...[activeC[1], activeC[3]]) + 1

        // 全選択かどうか判定
        var isSame1 = activeC[0] === 0
        var isSame2 = activeC[1] === 0
        var isSame3 = activeC[2] === this.headers.length - 1
        var isSame4 = activeC[3] === this.rows.length - 1
        isAllSelect = isSame1 && isSame2 && isSame3 && isSame4
      }

      var tmpRow = []
      for (let i = 0; i < num; i++) {
        const newrow = {
          sagyoYoteiYmd: date.getCurrentDate(),
          hatsuchiNm: null,
          chakuchiNm: null,
          sagyoTantoshaNm: null,
          hinmeiNm: null,
          denpyoHanyoBiko1: null,
          denpyoHanyoBiko2: null,
          tokuisakiNm: null,
          juchuEigyoshoNm: null,
          denpyoHanyoBiko3: null,
          denpyoHanyoBiko4: null,
          juchuTantoshaNm: null,
          denpyoHanyoSbt1: null,
          denpyoHanyoBiko5: null
        }
        tmpRow.push(newrow)
      }
      // 行追加
      if (lastFlg !== undefined && lastFlg) {
        this.rows.push(tmpRow)
        this.rows.splice()
      } else {
        if (isAllSelect || (aboveFlg !== undefined && aboveFlg)) {
          if (pos === 0) {
            this.rows.unshift(tmpRow)
          } else {
            this.rows.splice(pos - 1, 0, tmpRow)
          }
        } else {
          this.rows.splice(pos, 0, tmpRow)
        }
      }
    },

    onDummyFunction: function () {
      return null
    }
  }
}
